(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // חסימת קליק ימני
    document.body.addEventListener('contextmenu', function(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }, true);

    // חסימת גרירה
    document.addEventListener('dragstart', function(e) {
      if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO') {
        e.preventDefault();
        return false;
      }
    });

    // הגנה על תמונות
    document.querySelectorAll('img, video').forEach(function(el) {
      el.setAttribute('draggable', 'false');
    });
  });
})();